module.exports = __webpack_public_path__ + "static/media/image8.7e681b71.jpeg";